var _path, _path2, _path3, _line, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Csv50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#a5d6a7",
    d: "M32.8,9H16.2c-1.7,0-3.1,1.4-3.1,3.1V44c0,1.7,1.4,3.1,3.1,3.1h23.7c1.7,0,3.1-1.4,3.1-3.1V19.1 c0-0.5-0.2-1-0.6-1.4l-8.1-8.1C33.9,9.2,33.4,9,32.8,9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M38.5,21.9v-7.4h-6c-1.7,0-3-1.3-3-3v-6h-17c-1.7,0-3,1.3-3,3v8.7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M9.5,35.5v4c0,1.7,1.3,3,3,3h23c1.7,0,3-1.3,3-3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.5,
    x2: 29.5,
    y1: 14.5,
    y2: 5.5,
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18193f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M22.6,22.5h16.9c0.6,0,1,0.4,1,1v11c0,0.6-0.4,1-1,1h-31c-0.6,0-1-0.4-1-1v-11c0-0.6,0.4-1,1-1h7.2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#18193f",
    d: "M16.8,33c-1.8,0-3.3-1.8-3.3-4s1.5-4,3.3-4c1.4,0,2.3,1,2.6,1.6c0.2,0.5,0,1.1-0.5,1.3 c-0.5,0.2-1.1,0-1.3-0.4c0-0.1-0.3-0.5-0.8-0.5c-0.7,0-1.3,0.9-1.3,2s0.6,2,1.3,2c0.6,0,0.8-0.4,0.8-0.4c0.2-0.5,0.8-0.7,1.3-0.5 c0.5,0.2,0.7,0.8,0.5,1.3C19.1,32,18.2,33,16.8,33z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#18193f",
    d: "M24,33h-1.1c-1.1,0-1.8-0.6-2.1-0.9c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0c0.1,0.1,0.4,0.3,0.7,0.3H24 c0.3,0,0.5-0.2,0.5-0.5S24.3,30,24,30h-0.9c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5H24c1.1,0,1.9,0.7,2,0.8c0.4,0.4,0.4,1,0,1.4 s-1,0.4-1.4,0l0,0c0,0-0.2-0.2-0.5-0.2h-0.9c-0.3,0-0.5,0.2-0.5,0.5s0.2,0.5,0.5,0.5H24c1.4,0,2.5,1.1,2.5,2.5 C26.5,31.9,25.4,33,24,33z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#18193f",
    d: "M31,33c-0.4,0-0.8-0.2-0.9-0.6l-2.5-6c-0.2-0.5,0-1.1,0.5-1.3c0.5-0.2,1.1,0,1.3,0.5l1.6,3.8l1.6-3.8 c0.2-0.5,0.8-0.8,1.3-0.5c0.5,0.2,0.8,0.8,0.5,1.3l-2.5,6C31.8,32.8,31.4,33,31,33z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Csv50);
export default __webpack_public_path__ + "static/media/icons8-csv-50.47fdeb46685ba5a4a72b0e1f298e9d16.svg";
export { ForwardRef as ReactComponent };